import * as Dialog from '@radix-ui/react-dialog'
import { Link } from 'react-router-dom'
import { BookOpen, X } from 'lucide-react'
import { useWelcome } from '../hooks/useWelcome'

export default function WelcomeModal() {
  const { showWelcome, dismissWelcome, welcomeLoading } = useWelcome()

  if (welcomeLoading) return null

  function handleOpenChange(open: boolean) {
    if (!open) {
      dismissWelcome()
    }
  }

  return (
    <Dialog.Root open={showWelcome} onOpenChange={handleOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-50 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=closed]:fade-out-0" />
        <Dialog.Content className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-lg bg-card border border-border rounded-lg shadow-lg p-0 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95">
          {/* Close button */}
          <Dialog.Close asChild>
            <button
              className="absolute right-4 top-4 p-1.5 rounded-lg hover:bg-secondary transition-colors text-muted-foreground hover:text-foreground"
              aria-label="Close"
            >
              <X className="w-4 h-4" />
            </button>
          </Dialog.Close>

          <div className="px-8 pt-8 pb-6 text-center">
            {/* Logo */}
            <div className="flex justify-center mb-5">
              <div className="w-14 h-14 rounded-xl bg-primary flex items-center justify-center">
                <span className="text-primary-foreground font-bold text-xl">CC</span>
              </div>
            </div>

            {/* Title */}
            <Dialog.Title className="text-xl font-semibold mb-2">
              Welcome to CC Platform
            </Dialog.Title>

            {/* Subtitle */}
            <p className="text-muted-foreground mb-6">
              Your cloud development environment for building and deploying apps.
            </p>

            {/* Body */}
            <div className="space-y-3 text-sm text-muted-foreground text-left mb-8">
              <p>
                Create workspaces, build apps, and deploy them — all from your browser.
              </p>
              <p>
                Need help? Check out the User Guide for walkthroughs, or click the{' '}
                <span className="font-medium text-foreground">?</span> button on any page for quick help.
              </p>
            </div>

            {/* Actions */}
            <div className="flex flex-col gap-3">
              <button
                onClick={dismissWelcome}
                className="w-full px-4 py-2.5 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors"
              >
                Get Started
              </button>
              <Link
                to="/guide"
                onClick={() => dismissWelcome()}
                className="flex items-center justify-center gap-2 w-full px-4 py-2.5 border border-border rounded-lg text-sm font-medium hover:bg-secondary transition-colors"
              >
                <BookOpen className="w-4 h-4" />
                Explore the User Guide
              </Link>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
